



















































import { Prop, Component, Watch } from 'vue-property-decorator';
import CampaignParametersFormTypeBase from '../CampaignParametersFormTypeBase/CampaignParametersFormTypeBase';
import { Notification } from '../../../helpers/Notification';
import { Dialog, DialogValue, DialogValueTypeEnum, IAssetParameterValue, AssetParameterValue } from '@models';
import { Utility } from '../Utility';
import AssetService from '../../../services/AssetService';

@Component
export default class CampaignParametersFormSeenThisType extends CampaignParametersFormTypeBase {
  name = 'campaign-parameters-form-seenthis-type';

  lblShowStatus = '';
  statusCode;
  SeenThisId = '';

  filePreview = new Dialog();

  maxWeight = 120000000; //120MB

  @Prop({ type: String, default: "" })
  previewPath: string;
  isDeleteAvailable: boolean = false;
  assetService = AssetService;

  get inputPlaceholder() {
    this.lblShowStatus = '';
    if (this.value?.value && this.value?.value !== "") {
      var parsedValue = JSON.parse(this.value?.value);


      if (parsedValue.Id != null) {
        this.SeenThisId = parsedValue.Id;

        if (parsedValue.Status != null)
          this.lblShowStatus = 'Encoding Status: ' + parsedValue.Status;

        if (parsedValue.StatusCode != null)
          this.statusCode = parsedValue.StatusCode;
      }

    }

    return this.value?.file?.name || this.jsonValue?.UploadedFilename || '';
  }

  get file() {
    return this.local.file;
  }

  set file(file: File) {
    if (!file || typeof (file) === 'undefined') {
      if (this.isFileSelected) {
        this.$refs['fileSelector'].lazyValue = this.file;
      }
      return;
    };
    this.handleFileSelectionChange(file);
  }

  get isFileSelected() {
    return (this.file && typeof (this.file) !== 'undefined');
  }

  handleFileSelectionChange(file) {
    _context = this;
    _file = file;
    if (file.size > this.maxWeight) {
      this.notification.Error('Maximum file size exceeded! The size of videos must be under 120 MB.');
    }
    else {

      const supportedVideoFiles = ['video/mp4', 'video/webm', 'video/quicktime'];

      if (supportedVideoFiles.includes(file.type))//Supported element
      {
        setVideoOptions(file);

        this.update(v => {
          v.file = file;
          v.value = JSON.stringify(getJsonObject(file.name));
        });

      }
      else {
        this.notification.Error('File format is not supported! Use .mp4, .mov, .webm');
      }

    }
  }

  onFileSelectorClear(event) {
    this.update(v => {
      v.file = null;
      v.value = null;
    });

    this.isDeleteAvailable = false;
    this.jsonValue = null;
    this.inputKey++;
  }

  required = (value: any) => this.value?.value != '' || "Value is missing";

  get isPreviewAvailable(): boolean {
    return !!this.value?.file || !!this.jsonValue?.AssetPath;
  }

  getUploadStatus() {
    if ((this.SeenThisId != '') && (this.SeenThisId != 'undefined') && (this.SeenThisId != null)) {
      var response = this.assetService.updateSeenThisStatus((this.local.campaignId == null || this.local.campaignId == undefined) ? '' : this.local.campaignId.toString(), this.local.id, this.SeenThisId, (this.local.canvasContentId == null || this.local.canvasContentId == undefined) ? '' : this.local.canvasContentId.toString());
      response.then(r => {
        if (r.status === 200) {
          if (r.data?.value != null) {
            var returnedValue = JSON.parse(r.data?.value);
            if ((returnedValue.Id != null) && (returnedValue.StatusCode != null)) {
              this.lblShowStatus = 'Encoding Status: ' + returnedValue.Status;
              this.statusCode = returnedValue.StatusCode;
              this.value.value = r.data.value;
              this.$emit('input', this.value);
            }
            else {
              this.lblShowStatus = 'Encoding Status: Video transcoding failed. Try to re-upload the video.';
            }
          }
        }
        else {
          this.lblShowStatus = 'Could not get Status of the Video!';
          this.statusCode = null;
        }

      });
    }
  }

  previewVideo() {
    this.filePreview = new Dialog({
      formRef: 'filePreview',
      headline: 'Video preview',
      okText: 'Download',
      cancel: () => {
        this.filePreview = null;
      },
      values: [new DialogValue({
        type: DialogValueTypeEnum.video,
        id: "video_preview",
        label: "Video preview"
      })]
    });

    Utility.previewFileInModalDialog(this.value?.file, this.filePreview, this.previewPath, this.jsonValue);
  }

  @Watch('value.value')
  updateJson() {
    try {
      if (this.value?.value && this.value?.value !== "") {
        let seenThisStatus = JSON.parse(this.value.value);
        if (seenThisStatus.Id) {
          this.jsonValue = JSON.parse(this.value.value);
          this.isDeleteAvailable = true;
        }
      }

    } catch (e) {
      this.notification.Error("An error occurred while reading SeenThis parameter");
    }
  }

  created() {
    this.updateJson();

    setInterval(() => {
      if ((this.statusCode != null) && (this.statusCode < 2)) {
        this.getUploadStatus();
      }
    }, 8000)
  }
}

let _context;
let videoOptions = { height: null, width: null };
let _file;
const videoElement = document.createElement('video');
//EVENT listener that will set videoOptions when the "hidden" videoElement has loadedMetaData
videoElement.addEventListener("loadedmetadata", function (e) {
  videoOptions = { height: null, width: null };
  videoOptions.width = videoElement.videoWidth;
  videoOptions.height = videoElement.videoHeight;
  _context.update(v => {
    v.file = _file;
    v.value = JSON.stringify(getJsonObject(_file.name));
    v.file.videoOptions = videoOptions;
  });
}, false);

//Will load a video into the hidden videoElement.
function setVideoOptions(file) {
  const url = URL.createObjectURL(file);
  videoElement.src = url;

}

function getJsonObject(uploadedFileName: string): IAssetParameterValue {
  const jsonFile = new AssetParameterValue();
  jsonFile.UploadedFilename = uploadedFileName;

  return jsonFile;
}

